import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useCallback, useRef } from "react";
import { tokenDecode } from "../../../utils/helper";
import shikharapplogo from "../../../icons/logoimg.png"
import styles from "./navbar.module.css"
import bars from "../../../icons/MenuBar.png"
import shop from "../../../icons/shop.png"
import PublicIcon from '@mui/icons-material/Public';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { useLocation } from "react-router-dom";
import { FaUser } from "react-icons/fa";

const Navbar = (props) => {
    const history = useHistory();
    const logoutExecutedRef = useRef(false);
    const logoutTimerRef = useRef(null);
    const location = useLocation()
    // console.log("location---->", location)
    const token = sessionStorage.getItem("token");
    const decoded = tokenDecode();
    const userArray = decoded?.data?.user || decoded?.user || [];
    const userObj = Array.isArray(userArray) ? userArray[0] : (userArray || decoded?.data || {});
    const sellerArray = decoded?.data?.seller_data || decoded?.seller_data || [];
    const sellerObj = Array.isArray(sellerArray) ? sellerArray[0] : (sellerArray || {});
    const sellerId = userObj?.seller_id ?? decoded?.seller_id ?? decoded?.data?.seller_id ?? sessionStorage.getItem("seller_id");
    const isAdmin = String(sellerId) === "1" || userObj?.seller_id === "1" || userObj?.seller_id === 1;
    const userName = userObj?.name || userObj?.display_email || userObj?.email
        || (isAdmin ? "Admin" : "User");

    const rawApproveStatus = sellerObj?.approve_status !== undefined && sellerObj?.approve_status !== null
        ? sellerObj.approve_status
        : userObj?.approve_status;
    const isApproved = isAdmin || (rawApproveStatus !== undefined && rawApproveStatus !== null && Number(rawApproveStatus) === 1);
    const adminseller = userObj?.seller_id == null

    // console.table("dfghj45678dfghj", typeof (userObj?.seller_id))
    // console.table("dfghj45678dfghj", adminseller)

    const logouthandler = useCallback(() => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('is_activated');
        sessionStorage.removeItem('seller_approved');
        sessionStorage.removeItem('isSkipped');
    }, []);

    const handleLogout = useCallback(() => {
        if (!logoutExecutedRef.current) {
            logoutExecutedRef.current = true;
            logouthandler();
            history.push('/');
        }
    }, [history, logouthandler]);

    useEffect(() => {
        const decoded = token && tokenDecode(token);
        const expirationTime = decoded?.exp * 1000;
        // const expirationDateTime = new Date(decoded.exp * 1000);
        // console.log('Token expired on:', expirationDateTime);
        if (expirationTime) {
            const delay = expirationTime - Date.now();
            if (delay > 0 && delay < 2147483647) {
                logoutTimerRef.current = setTimeout(handleLogout, delay);
            }
        }

        return () => {
            clearTimeout(logoutTimerRef.current);
        };
    }, [token, handleLogout]);

    const [heading, setHeading] = useState({
        name: "",
        icon: "",
    })
    function getHeading(route) {
        if (route === "/addseller") {
            setHeading((prev) => { return { ...prev, name: "Register seller" } })
        }
        if (route === "/dashboard") {
            setHeading((prev) => { return { ...prev, name: "Analytics" } })
        }
        if (route === "/sellerdetail") {
            setHeading((prev) => { return { ...prev, name: "Warehouses" } })
        }
        if (route === "/inventoryless") {
            setHeading((prev) => { return { ...prev, name: "All Biddings" } })
        }
        if (route === "/findproduct") {
            setHeading((prev) => { return { ...prev, name: "Find Product" } })
        }
        if (route === "/addwarehouse") {
            setHeading((prev) => { return { ...prev, name: "Add warehouse" } })
        }
        if (route === "/addvariants") {
            setHeading((prev) => { return { ...prev, name: "Add variants" } })
        }
        if (route === "/variantslist") {
            setHeading((prev) => { return { ...prev, name: "Variants List" } })
        }
        if (route === "/warehousefulfillment") {
            setHeading((prev) => { return { ...prev, name: "Warehouse fulfillment" } })
        }
        if (route === "/createproduct") {
            setHeading((prev) => { return { ...prev, name: "Add product" } })
        }
        if (route === "/instorecatalog") {
            setHeading((prev) => { return { ...prev, name: "All products" } })
        }
        if (route === "/newcategory" || route === "/category") {
            setHeading((prev) => { return { ...prev, name: "Categories" } })
        }
        if (route === "/brand") {
            setHeading((prev) => { return { ...prev, name: "Brands" } })
        }
        if (route === "/serviceability" || route === "/warehouseserviceability") {
            setHeading((prev) => { return { ...prev, name: "Serviceability" } })
        }
        if (route === "/customerrder") {
            setHeading((prev) => { return { ...prev, name: "Customer Order List" } })
        }
        if (route === "/completeOrder") {
            setHeading((prev) => { return { ...prev, name: "Complete Order List" } })
        }
        if (route === "/producttypelist") {
            setHeading((prev) => { return { ...prev, name: "Product Types List" } })
        }

        if (route === "/producttype") {
            setHeading((prev) => { return { ...prev, name: "Add Product Type" } })
        }
        if (route === "/productlist") {
            setHeading((prev) => { return { ...prev, name: "Product List" } })
        }
        if (route === "/roles") {
            setHeading((prev) => { return { ...prev, name: "Roles" } })
        }
        if (route === "/issues") {
            setHeading((prev) => { return { ...prev, name: "Issues" } })
        }
        if (route === "/ticketsupport") {
            setHeading((prev) => { return { ...prev, name: "Support Ticket" } })
        }
        if (route === "/buyerfee") {
            setHeading((prev) => { return { ...prev, name: "Buyer fee" } })
        }
        if (route === "/orderlist") {
            setHeading((prev) => { return { ...prev, name: "Order List" } })
        }
        if (route === "/returnorders") {
            setHeading((prev) => { return { ...prev, name: "Return Order List" } })
        }
        if (route === "/cancelOrderlist") {
            setHeading((prev) => { return { ...prev, name: "Cancel Order List" } })
        }
        if (route === "/userlist") {
            setHeading((prev) => { return { ...prev, name: "User List" } })
        }
        if (route === "/Sellerdetails_kyc") {
            setHeading((prev) => { return { ...prev, name: "Seller KYC" } })
        }
        if (route === "/adduser") {
            setHeading((prev) => { return { ...prev, name: "Add a new user" } })
        }
        if (route === "/onboardingform") {
            setHeading((prev) => { return { ...prev, name: "Onboarding Form" } })
        }
        if (route === "/loglist") {
            setHeading((prev) => { return { ...prev, name: "Logs" } })
        }
        if (route === "/unsettledtransactions") {
            setHeading((prev) => { return { ...prev, name: "Unsettled Transactions List" } })
        }
        if (route === "/sellerDetails" || route === "/sellerdetails") {
            setHeading((prev) => { return { ...prev, name: isAdmin ? "Admin Details" : "Seller Details" } })
        }
        if (route === "/transaction") {
            setHeading((prev) => { return { ...prev, name: "Settled Transactions List" } })
        }
        if (route === "/productcatalog") {
            setHeading((prev) => { return { ...prev, name: "Master Catalog" } })
        }
        if (route === "/customerorder") {
            setHeading((prev) => { return { ...prev, name: "Customer Order List" } })
        }

        if (route === "/settings") {
            setHeading((prev) => { return { ...prev, name: "Connect Your Online Store" } })
        }

        if (route.startsWith("/warehousefulfillment")) {
            setHeading((prev) => ({
                ...prev,
                name: "Warehouses fulfillments"
            }))
        }
        if (route.startsWith("/addwarehouse")) {
            setHeading((prev) => ({
                ...prev,
                name: "Warehouses"
            }))
        }
        if (route.startsWith("/warehouseserviceability")) {
            setHeading((prev) => ({
                ...prev,
                name: "Warehouse serviceability"
            }))
        }
    }
    useEffect(() => {
        getHeading(location.pathname)
    }, [location.pathname])


    return (
        <>
            <nav className={`navbar navbar-expand navbar-light topbar sticky-top ${styles.mobile_navbar}`}>
                <button id="sidebarToggleTop" className={`btn btn-link rounded-circle mr-3 ${styles.burgerButton}`} onClick={() => props.Showmenu()}>
                    <img src={bars} alt="" style={{ height: "70%" }} />
                </button>

                <div className="d-flex justify-content-between w-100 align-items-center">
                    <h1 className="m-0 pl-3 d-flex align-items-center" style={{ fontSize: "1.35rem", color: "#0F172A", fontWeight: 700, letterSpacing: "-0.3px", gap: "8px" }}>
                        <QueryStatsIcon style={{ color: "#F97316", fontSize: "24px" }} />
                        <span>{heading?.name}</span>
                    </h1>
                    <ul className="navbar-nav">
                        <div className="topbar-divider d-none d-sm-block"></div>
                        <li className={`nav-item dropdown no-arrow ${styles.plus}`} >
                            <Link to="#" className="nav-link dropdown-toggle" id="userDropdown" role="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                style={{ display: "flex", alignItems: "center", gap: "6px" }}
                            >
                                <span className="mr-1 d-none d-lg-inline text-gray-700 font-weight-bold small">{userName}</span>
                                <img className={`img-profile rounded-circle ${styles.dropdownimg}`}
                                    src={`/img/undraw_profile.svg`} alt="User Profile" />

                                <div className={styles.searchOpener}>
                                    <i className="fa fa-plus-circle" aria-hidden="true"></i>
                                </div>
                            </Link>

                            <div className={`dropdown-menu shadow-lg animated--grow-in p-0 ${styles.dropDownPosition}`}
                                aria-labelledby="userDropdown">
                                <div className={styles.doropdownnavmenu}>
                                    <div className={styles.userDropdownHeader}>
                                        <div className={styles.userDropdownName}>{userName}</div>
                                        <div className={styles.userDropdownEmail}>
                                            {userObj?.email || userObj?.display_email || (isAdmin ? "Admin Account" : "Seller Account")}
                                        </div>
                                    </div>

                                    <div className={styles.menuItemsList}>
                                        {(isApproved && !adminseller) && (
                                            <>
                                                <Link to="/sellerdetail?tab=shopdetails" className={styles.menuItemLink}>
                                                    <div className={styles.menuIconBox} style={{ backgroundColor: "#FFF7ED", color: "#F97316" }}>
                                                        <i className="fas fa-warehouse"></i>
                                                    </div>
                                                    <span className={styles.menuItemText}>Warehouse</span>
                                                </Link>

                                                <Link to="/sellerDetails" className={styles.menuItemLink}>
                                                    <div className={styles.menuIconBox} style={{ backgroundColor: "#EFF6FF", color: "#3B82F6" }}>
                                                        <FaUser />
                                                    </div>
                                                    <span className={styles.menuItemText}>{isAdmin ? "Admin Details" : "Seller Details"}</span>
                                                </Link>

                                                <div className={styles.menuDivider}></div>
                                            </>
                                        )}

                                        <button
                                            type="button"
                                            onClick={handleLogout}
                                            className={`${styles.menuItemLink} ${styles.logoutItem}`}
                                            style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}
                                        >
                                            <div className={styles.menuIconBox} style={{ backgroundColor: "#FEF2F2", color: "#EF4444" }}>
                                                <i className="fas fa-sign-out-alt"></i>
                                            </div>
                                            <span className={styles.menuItemText}>Logout</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </li>
                        {/* } */}

                    </ul>
                </div>

            </nav>
        </>
    )
}

export default Navbar;